<template>
  <form @submit.prevent="registrar" class="formulario-contacto">
    <b-field label="Nombre">
      <b-input
        icon="account"
        type="text"
        placeholder="Ej. Don Henry"
        v-model="datosCliente.nombre"
        required
      />
    </b-field>

    <b-field label="Teléfono">
      <b-input
        icon="phone"
        type="tel"
        placeholder="Ej. 573001234567"
        v-model="datosCliente.telefono"
        maxlength="12"
        required
      />
    </b-field>

    <b-field label="Ciudad">
      <b-input
        icon="city"
        type="text"
        placeholder="Ej. Medellín"
        v-model="datosCliente.ciudad"
      />
    </b-field>

    <b-field label="placa">
      <b-input
        icon="tag"
        type="text"
        placeholder="Ej. Barrios Central"
        v-model="datosCliente.placa"
      />
    </b-field>

    <b-field label="Selecciona una categoría">
      <b-select
        placeholder="Categoría"
        icon="archive"
        v-model="datosCliente.idCategoria"
        @input="asignarNombreCategoria"
      >
        <option
          v-for="categoria in categorias"
          :key="categoria.id"
          :value="categoria.id"
        >
          {{ categoria.nombreCategoria }}
        </option>
      </b-select>
    </b-field>

    <div class="buttons is-centered mt-4">
      <b-button type="is-primary" icon-left="check" native-type="submit">
        Registrar
      </b-button>
      <b-button
        type="is-light"
        icon-left="cancel"
        tag="router-link"
        to="/clientes"
      >
        Cancelar
      </b-button>
    </div>
  </form>
</template>

<script>
import HttpService from "../../Servicios/HttpService";
import Swal from "sweetalert2";

export default {
  name: "FormCliente",
  props: ["cliente"],

  data() {
    return {
      datosCliente: {
        nombre: "",
        telefono: "",
        ciudad: "",
        placa: "",
        idCategoria: "",
        nombreCategoria: "",
      },
      categorias: [],
    };
  },

  mounted() {
    if (this.cliente) {
      this.datosCliente = { ...this.cliente };
    }
    this.obtenerCategorias();
  },

  methods: {
    obtenerCategorias() {
      const payload = { accion: "obtener" };
      HttpService.obtenerConConsultas("categorias.php", payload).then(
        (categorias) => {
          this.categorias = categorias;
        }
      );
    },

    asignarNombreCategoria(idSeleccionado) {
      const cat = this.categorias.find(c => c.id === idSeleccionado);
      if (cat) {
        this.datosCliente.nombreCategoria = cat.nombreCategoria;
      }
    },

    registrar() {
      const { nombre, telefono } = this.datosCliente;

      if (!nombre || !telefono) {
        Swal.fire("Campos obligatorios", "El nombre y el teléfono son requeridos.", "warning");
        return;
      }

      const regex = /^57\d{10}$/;
      if (!regex.test(telefono)) {
        Swal.fire(
          "Teléfono inválido",
          "Debe iniciar con 57 y tener 12 dígitos exactos.",
          "error"
        );
        return;
      }

      this.$emit("registrar", { ...this.datosCliente });

      Swal.fire("¡Registrado!", "El contacto ha sido guardado.", "success");

      // Limpiar
      this.datosCliente = {
        nombre: "",
        telefono: "",
        ciudad: "",
        placa: "",
        idCategoria: "",
        nombreCategoria: "",
      };
    },
  },
};
</script>

<style scoped>
.formulario-contacto {
  max-width: 500px;
  margin: auto;
}
</style>
